import { replaceLastApiPath } from '../url/publicUrl';

const AUTH_PREFIX = '/auth/';

/**
 * string-based equivalent of getPublicPageURL for server-side usage.
 * replaces the last /api/ with /auth/ in the url path, preserving any /api/ in the path prefix.
 */
export const getPublicPageURLString = (url: string): string => replaceLastApiPath(url, AUTH_PREFIX);
